import React from 'react';
import './MyContent.css'; // Import the CSS file

const MyContent = () => {
  return (
    <div className="mycontent">
      <h2>SONEL</h2>
      <h2>SONEL</h2>
    </div>
  );
};

export default MyContent;
